'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/_rc-checkbox@1.5.0@rc-checkbox/lib/index.js
 ** module id = 219
 ** module chunks = 0 1
 **/